// Module
var code = `<glue-container prepend="\$ctrl.prepend">
  <div class="cash">
    <input type="text"
           ng-class="{'cash__input': !\$ctrl.hideCurrency}"
           ng-currency
           ng-model="\$ctrl.cashValue"
           ng-change="\$ctrl.valueChanged()"
           ng-disabled="\$ctrl.\$attrs.disabled"
           ng-min="\$ctrl.min"
           ng-max="\$ctrl.max"
           fraction="{{\$ctrl.fraction}}"
           currency-symbol/>
    <label ng-if="!\$ctrl.hideCurrency"
      class="cash__label">{{ \$ctrl.currency }}</label>
  </div>
</glue-container>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/cash/cash.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;